import { CardActionArea, CardHeader } from '@mui/material';

import ChatIcon from '@mui/icons-material/Chat';
import { tss } from 'tss-react/mui';

import { Or2Card } from '@/components/Surface/Or2Card';

import { Or2Avatar } from '../../components/Avatar/Or2Avatar';

const useStyles = tss.create(({ theme }) => {
  return {
    avatar: {
      backgroundColor: theme.palette.primary.main,
    },
  };
});

interface Props {
  className?: string;
}

export const GovernorhubBlog = ({ className }: Props) => {
  const { classes } = useStyles();
  return (
    <Or2Card className={className}>
      <CardActionArea
        href="https://thehoot.news"
        target="_blank"
        rel="noreferrer noopener"
      >
        <CardHeader
          avatar={
            <Or2Avatar alt="The Hoot icon" className={classes.avatar}>
              <ChatIcon />
            </Or2Avatar>
          }
          title={'Governor News from The Hoot'}
        />
      </CardActionArea>
    </Or2Card>
  );
};
